let once = false;

export function initRLayout(){
    if (once) return;
    once = true;

    webix.protoUI(
        {
            name: "r-layout",
            sizeTrigger(app, handler, value) {
                this._compactValue = value;
                this._compactHandler = handler;
                this._app = app;

                const config = app.config;
                this._forceCompact = typeof config.params.forceCompact !== "undefined";
                this._compactWidth = config.compactWidth;

                if (!this._forceCompact) this._checkTrigger(this.$view.width, value);
            },
            _checkTrigger(x, value) {
                if (this._compactWidth) {
                    if (
                        (x <= this._compactWidth && !value) ||
                        (x > this._compactWidth && value)
                    ) {
                        this._compactWidth = null;
                        this._compactHandler(!value);
                        return false;
                    }
                }
                return true;
            },
            $setSize(x, y) {
                if (this._forceCompact || this._checkTrigger(x, this._compactValue))
                    webix.ui.layout.prototype.$setSize.call(this, x, y);
                if (this._app) this._app.callEvent("view:resize", []); //edit popup resize
            },
        },
        webix.ui.layout
    );
}
